import { User } from '@src/entities/User/ui/components/User';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { useFormFieldArray } from '@uhg-abyss/web/hooks/useFormFieldArray';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Link } from '@uhg-abyss/web/ui/Link';
import React from 'react';

import { Table } from './components/Table';
import { Styles } from './includes/styles';

/**
 * RepeatableFields
 *
 * @TODO Needs description.
 *
 * @param accessor
 * @param defaultValues
 * @param disabledFields
 * @param fields
 * @param form
 * @param permissions
 * @returns {Element}
 * @constructor
 */
export function RepeatableFields({
  accessor = '',
  defaultValues = [],
  disabledFields = {},
  fields = [],
  form = {
    control: {
      fields: {
        append: () => {},
        remove: () => {},
      },
    },
    getValues: () => {},
  },
  permissions = {
    add: {
      attributes: [],
      isAllowed: null,
      resource: '',
    },
    edit: {
      attributes: [],
      isAllowed: null,
      resource: '',
    },
    remove: {
      attributes: [],
      isAllowed: null,
      resource: '',
    },
  },
}) {
  const {
    append,
    fields: repeatableFields,
    remove,
  } = useFormFieldArray({
    control: form.control,
    name: accessor,
  });

  const values = form?.getValues(accessor);

  return (
    <ErrorHandler location="src/shared/ui/components/RepeatableFields/RepeatableFields.jsx">
      <Styles>
        <Grid>
          <Grid.Col span={{ xs: '100%' }}>
            <Layout.Group alignLayout="right">
              <User.Capability
                alias="add"
                attributes={permissions?.add?.attributes}
                isAllowed={permissions?.add?.isAllowed}
                resource={permissions?.add?.resource}
              >
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <Link
                  id="addRow"
                  onClick={() => {
                    append(defaultValues);
                  }}
                  variant="custom"
                >
                  <Flex alignItems="center">
                    <div>
                      <IconSymbol icon="add_circle" variant="filled" />
                      <IconSymbol icon="add_circle" variant="outlined" />
                    </div>
                    <div>Add Row</div>
                  </Flex>
                </Link>
              </User.Capability>
            </Layout.Group>
            <Table
              {...{
                accessor,
                disabledFields,
                fields,
                permissions,
                remove,
                repeatableFields,
                rows: values,
              }}
            />
          </Grid.Col>
        </Grid>
      </Styles>
    </ErrorHandler>
  );
}
